import { Injectable, Inject, Optional } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import * as express from './express-ssr';

/**
 * A class for retrieving and doing basic analysis of the browser's user agent 
 * string, both from the server-side and the client-side.
 */
@Injectable()
export class UserAgent {
    constructor(
        @Inject(REQUEST)
        @Optional() 
        private request : express.ExpressRequest
    ) {
        
    }
    
    toString() {
        if (typeof navigator !== 'undefined') {
            return navigator.userAgent;
        } else if (this.request) {
            return this.request.headers['User-Agent'];
        } else {
            return null;
        }
    }

    get os() {
        let str = this.toString();

        if (!str)
            return 'unknown';

        if (str.indexOf('Xbox One') >= 0)
            return 'xbox-one';
        
        if (str.indexOf('PlayStation 4') >= 0)
            return 'ps4';
        
        if (str.indexOf('PLAYSTATION 3') >= 0)
            return 'ps3';
        
        if (str.indexOf('(PlayStation Vita') >= 0)
            return 'ps-vita';

        if (str.indexOf('Nintendo WiiU') >= 0)
            return 'wii-u';
        
        if (str.indexOf('Nintendo Wii') >= 0)
            return 'wii';
        
        if (str.indexOf('Android') >= 0)
            return 'android';
        
        if (str.indexOf('Linux') >= 0)
            return 'linux';
        
        if (str.indexOf('iPhone') >= 0 || str.indexOf('iPad') >= 0)
            return 'ios';

        if (str.indexOf('Windows') >= 0)
            return 'windows';

        if (str.indexOf('Mac OS X') >= 0)
            return 'osx';

        return 'unknown';
    }

    get browser() {
        let str = this.toString();

        if (!str)
            return 'unknown';

        if (str.indexOf('(Nintendo WiiU)') >= 0)
            return 'wii-u';
        
        if (str.indexOf('(PlayStation 4') >= 0)
            return 'ps4';

        if (str.indexOf('(PlayStation Vita') >= 0)
            return 'ps-vita';

        if (str.indexOf('PLAYSTATION 3') >= 0)
            return 'ps3';
            
        if (str.indexOf('Firefox/') >= 0)
            return 'firefox';

        if (str.indexOf('Edge/') >= 0)
            return 'edge';
        
        if (str.indexOf('Chrome/') >= 0)
            return 'chrome';
        
        if (str.indexOf('Safari/') >= 0) {
            if (str.indexOf('Android') >= 0) {
                return 'android';
            }

            return 'safari';
        }

        if (str.indexOf('; MSIE ') >= 0)
            return 'ie';
        
        if (str.indexOf('Presto/') >= 0)
            return 'opera';

        return 'unknown';
    }
}